<!-- filepath: /src/components/VideoMarkers.vue -->
<template>
    <!-- Polígono de la cámara -->
    <l-geo-json v-if="currentVideoDetail && isVideoLibrary" :geojson="JSON.parse(currentVideoDetail.cam_polygon)"
        :options-style="getLayerStyle('camPolygon')" />

    <!-- Avión -->
    <l-marker v-if="currentVideoDetail && isVideoLibrary"
        :lat-lng="[Number(currentVideoDetail.sensor_lat), Number(currentVideoDetail.sensor_lon)]">
        <l-icon :iconSize="[24, 24]" :iconAnchor="[12, 12]" class-name="point-event">
            <div class="pointicon">
                <div class="d-flex justify-content-center align-items-center"
                    style="width: 24px; height: 24px; background-color: white; border-radius: 15%; opacity: 0.5;">
                    <i class="bi bi-airplane" style="font-size: 24px; color: black;"
                        :style="{ transform: `rotate(${currentVideoDetail.platform_heading}deg)` }"></i>
                </div>
            </div>
        </l-icon>
    </l-marker>

    <!-- Curva del avión -->
    <l-polyline v-if="currentVideoDetail && isVideoLibrary && curvePoints.length" :lat-lngs="curvePoints"
        :color="'#ff6600'" :weight="3" :opacity="0.5" />

    <!-- Línea entre sensor y centro del video -->
    <l-polyline v-if="currentVideoDetail && isVideoLibrary" :lat-lngs="[
        [Number(currentVideoDetail.sensor_lat), Number(currentVideoDetail.sensor_lon)],
        [Number(currentVideoDetail.center_lat), Number(currentVideoDetail.center_lon)]
    ]" :color="'#808080'" :weight="3" :opacity="0.5" />

    <!-- Marcadores de videos agrupados -->
    <l-marker-cluster-group v-if="isVideoLibrary" :options="{ maxClusterRadius: 1 }">
        <l-marker v-for="video in videoDetails" :key="video.frametime" :title="video.video_id"
            :lat-lng="[Number(video.center_lat), Number(video.center_lon)]"
            @click.left="selectMarker(Number(video.frametime))">
            <l-icon :iconSize="[16, 16]" :iconAnchor="[8, 8]" class-name="point-event">
                <div class="pointicon"
                    :class="{ 'selected-video-marker': globalStore.selectedVideoMarker === Number(video.frametime) }">
                    <div class="d-flex justify-content-center align-items-center"
                        style="width: 16px; height: 16px; background-color: white; border-radius: 15%; opacity: 0.5;">
                        <i class="bi bi-film" style="font-size: 16px; color: black;"></i>
                    </div>
                </div>
            </l-icon>
            <l-tooltip>
                {{ video.video_id }}<br>
                {{ video.video_id }} m
            </l-tooltip>
        </l-marker>
    </l-marker-cluster-group>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { LGeoJson, LMarker, LIcon, LTooltip, LPolyline } from "@vue-leaflet/vue-leaflet"
import { LMarkerClusterGroup } from 'vue-leaflet-markercluster'
import { useVideos } from '@/composables/useVideos'
import { useGlobalStore } from '@/stores/global'
import { storeToRefs } from 'pinia'

const props = defineProps<{
    isVideoLibrary: boolean
    getLayerStyle: Function
}>()
const globalStore = useGlobalStore()
const { selectedVideoMarker } = storeToRefs(globalStore)
const { videoDetails, currentVideoDetail } = useVideos()

const curvePoints = computed(() =>
    videoDetails.value.map(v => [Number(v.sensor_lat), Number(v.sensor_lon)] as [number, number])
)
function selectMarker(videoId: number) {
    selectedVideoMarker.value = videoId
}
</script>
<style scoped>
.selected-video-marker {
    box-shadow: 0 0 0 4px #ffb300, 0 0 8px 4px #fff7d6;
    border-radius: 50%;
}
</style>